import axios from "axios";
import { useState } from "react";
import { ONE_MAP_URL } from "./OneMapURL";

export default function AddressDetail(searchVal: string) {
  return axios
    .request({
      method: "GET",
      url: `${ONE_MAP_URL}`,
      params: {
        searchVal,
        getAddrDetails: "Y",
        returnGeom: "Y",
        pageNum: 1,
      },
    })
    .then((res) => {
      return res.data.results[0];
    })
    .catch((e) => {
      console.log(e);
    });
}
